// eslint-disable
// this is an auto generated file. This will be overwritten

export const getNdc = `query GetNdc($id: ID!) {
  getNdc(id: $id) {
    id
    label
    notation
    prefLabel
    broader
    narrower
    note
    related
    seeAlso
  }
}
`;
export const listNdcs = `query ListNdcs($filter: ModelNdcFilterInput, $limit: Int, $nextToken: String) {
  listNdcs(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      label
      notation
      prefLabel
      broader
      narrower
      note
      related
      seeAlso
    }
    nextToken
  }
}
`;
export const getIndex = `query GetIndex($primary: String!, $secondary: String!) {
  getIndex(primary: $primary, secondary: $secondary) {
    primary
    secondary
    id
    label
    literalForm
    transcription
  }
}
`;
export const listIndexs = `query ListIndexs(
  $primary: String
  $secondary: ModelStringKeyConditionInput
  $filter: ModelIndexFilterInput
  $limit: Int
  $nextToken: String
) {
  listIndexs(
    primary: $primary
    secondary: $secondary
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      primary
      secondary
      id
      label
      literalForm
      transcription
    }
    nextToken
  }
}
`;



// WEBPACK FOOTER //
// ./src/graphql/queries.js